/** API base used when frontend runs on localhost (avoids baked-in production URLs). */
export const LOCAL_API_BASE_URL = 'http://127.0.0.1:8000/api';

const isLocalFrontendHost = (): boolean => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
};

const isRemoteVyhanApi = (url: string): boolean => /vyhan\.cloud/i.test(url);

/**
 * Resolve API base URL from env, but force local backend when the app is opened on localhost
 * (e.g. serving a production build locally still pointed at apintxbox.vyhan.cloud).
 */
export const getApiBaseUrl = (): string => {
  const fromEnv =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    LOCAL_API_BASE_URL;

  if (isLocalFrontendHost() && isRemoteVyhanApi(fromEnv)) {
    return LOCAL_API_BASE_URL;
  }

  return fromEnv;
};

export const getBackendBaseUrl = (): string =>
  getApiBaseUrl().replace(/\/api\/?$/, '');
